var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-card", {
    staticClass: "empty-card",
    attrs: { "card-header": "" },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "bold" }, [
              _vm._v(_vm._s(_vm._f("fullName")(_vm.details))),
            ]),
            _vm._v("\n    " + _vm._s(" ") + "\n    "),
            _vm.addition
              ? _c("i18n", {
                  attrs: {
                    path: "client-profile.actions.profileAddedToDripCampaign",
                    tag: "span",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "campaignName",
                        fn: function () {
                          return [
                            _c(
                              "router-link",
                              {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.top",
                                    value: _vm.campaignTitle,
                                    expression: "campaignTitle",
                                    modifiers: { top: true },
                                  },
                                ],
                                staticClass: "bold",
                                class: _vm.campaignClass,
                                attrs: { to: _vm.dripCampaignDetailsPath },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.campaignName) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "date",
                        fn: function () {
                          return [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm._f("momentLocal")(
                                      _vm.createdAt,
                                      "MMM. DD, YYYY"
                                    )
                                  ) +
                                  " @\n          " +
                                  _vm._s(
                                    _vm._f("momentLocal")(_vm.createdAt, "LT")
                                  ) +
                                  "\n        "
                              ),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2068577175
                  ),
                })
              : _vm.deleted
              ? _c("i18n", {
                  attrs: {
                    path: "client-profile.actions.profilDeletedFromDripCampaign",
                    tag: "span",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "campaignName",
                      fn: function () {
                        return [
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.top",
                                  value: _vm.campaignTitle,
                                  expression: "campaignTitle",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass: "bold",
                              class: _vm.campaignClass,
                              attrs: { to: _vm.dripCampaignDetailsPath },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.campaignName) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "date",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("momentLocal")(
                                    _vm.updatedAt,
                                    "MMM. DD, YYYY"
                                  )
                                ) +
                                " @\n          " +
                                _vm._s(
                                  _vm._f("momentLocal")(_vm.updatedAt, "LT")
                                ) +
                                "\n        "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                })
              : _c("i18n", {
                  attrs: {
                    path: "client-profile.actions.profileSentToDripCampaign",
                    tag: "span",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "campaignName",
                      fn: function () {
                        return [
                          _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.top",
                                  value: _vm.campaignTitle,
                                  expression: "campaignTitle",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass: "bold",
                              class: _vm.campaignClass,
                              attrs: { to: _vm.dripCampaignDetailsPath },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.campaignName) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "stageNumber",
                      fn: function () {
                        return [
                          _vm._v(
                            "\n        " + _vm._s(_vm.stageNumber) + "\n      "
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "date",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm._f("momentLocal")(
                                    _vm.sentAt,
                                    "MMM. DD, YYYY"
                                  )
                                ) +
                                " @\n          " +
                                _vm._s(
                                  _vm._f("momentLocal")(_vm.sentAt, "LT")
                                ) +
                                "\n        "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }